import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type ForwardersQueryVariables = GraphQLTypes.Exact<{
  networkId: GraphQLTypes.Scalars['String']['input'];
  searchContains: GraphQLTypes.LocationSearchInput;
}>;

export type ForwardersQueryResult = { __typename?: 'Query' } & {
  forwarders?: GraphQLTypes.Maybe<
    { __typename?: 'LocationAssignableConnection' } & {
      nodes?: GraphQLTypes.Maybe<
        Array<
          GraphQLTypes.Maybe<
            | { __typename?: 'Account' }
            | { __typename?: 'AccountLocation' }
            | { __typename?: 'NetworksLegacyOrgLoc' }
            | ({ __typename?: 'NetworksOrgLoc' } & Pick<GraphQLTypes.NetworksOrgLoc, 'id'> & {
                  label?: GraphQLTypes.Maybe<
                    { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
                  >;
                  organisation?: GraphQLTypes.Maybe<
                    { __typename?: 'NetworksOrgLocOrganisation' } & Pick<GraphQLTypes.NetworksOrgLocOrganisation, 'id' | 'name'>
                  >;
                })
            | { __typename?: 'NetworksTerminal' }
          >
        >
      >;
    }
  >;
};

export const ForwardersQueryDocument = gql`
  query forwardersQuery($networkId: String!, $searchContains: LocationSearchInput!) {
    forwarders(networkId: $networkId, searchContains: $searchContains) {
      nodes {
        ... on NetworksOrgLoc {
          id
          label {
            long
            short
          }
          organisation {
            id
            name
          }
        }
      }
    }
  }
`;
